export default __webpack_public_path__ + "static/media/Digital_India_logo.svg.5377bf80.png";